import { render } from "./HomePage.vue?vue&type=template&id=6417044c&scoped=true"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=6417044c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6417044c"]])

export default __exports__